import React from "react";
import { Radio } from "antd";

const ActualOrPlanned = ({isReconciliationForm, requestBody, setRequestBody}) => {
  return !isReconciliationForm && 
  (<div style={{ display: "flex", marginTop: "32px" }}>
    <Radio.Group
      onChange={e => {                
        setRequestBody({
          ...requestBody,          
          status: {
            confirmed: e.target.value
          },
          /*
          payment: {
            ...requestBody.payment,
            type: !e.target.value ? "item_pays" : requestBody.payment.type
          },
          */
          totalAmount: !e.target.value ? 0 : requestBody.totalAmount
        });
      }
      }
      value={requestBody.status.confirmed}
    >
      <Radio value={true}>Effettiva</Radio>
      <Radio value={false}>Pianificata</Radio>
    </Radio.Group>
  </div>
  );
};

export default ActualOrPlanned;